import { combineReducers } from 'redux';
import Auth from './Auth';
import Theme from './Theme';
import Session from './Session';

const reducers = combineReducers({
    theme: Theme,
    auth: Auth,
    session: Session,
});

export default reducers;